import { styled } from "@mui/material/styles";

const PREFIX = "NavTableOfContents";
export const classes = {
  root: `${PREFIX}-root`,
  item: `${PREFIX}-item`,
  itemSelected: `${PREFIX}-itemSelected`,
  textSelected: `${PREFIX}-textSelected`,
  link: `${PREFIX}-link`,
};

export const NavTableOfContents = styled("nav")(({ theme }) => ({
  [`&.${classes.root}`]: {
    position: "fixed",
  },
  [`& .${classes.item}`]: {
    borderLeft: `2px solid ${theme.palette.gray.main}`,
  },
  [`& .${classes.itemSelected}`]: {
    borderLeft: `2px solid ${theme.palette.primary.main}`,
    backgroundColor: theme.palette.background.paper,
  },
  [`& .${classes.textSelected}`]: {
    color: theme.palette.primary.main,
  },
  [`& .${classes.link}`]: {
    cursor: "pointer",
    ["&:first-letter"]: {
      textTransform: "uppercase",
    },
  },
}));
